import { Badge, Card, Group, Stack, Switch, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../lib/api';
import { useMe } from '../../lib/me';
import { PageHeader } from '../../ui/PageHeader';

export function ProfilePage() {
  const me = useMe();
  const qc = useQueryClient();
  const save = useMutation({
    mutationFn: (remindersEnabled: boolean) => api.patch('/me/settings', { remindersEnabled }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['me'] }),
    onError: (e: Error) => notifications.show({ color: 'red', message: e.message }),
  });
  const row = (label: string, value: React.ReactNode) => (
    <Group justify="space-between" wrap="nowrap"><Text size="sm" c="dimmed">{label}</Text><Text size="sm" ta="right">{value}</Text></Group>
  );
  return (
    <>
      <PageHeader title="Профиль" subtitle="Данные из справочника сотрудников. Изменить их может HR." />
      <Stack maw={560}>
        <Card withBorder radius="lg" padding="lg">
          <Stack gap="xs">
            {row('ФИО', me.fullName)}
            {row('Email', me.email)}
            {row('Табельный номер', me.employeeId ?? '-')}
            {row('Подразделение', me.department ?? '-')}
            {row('Часовой пояс', me.timezone)}
            {me.roleLabels.length > 0 && row('Роли в команде обучения', <Group gap={4} justify="flex-end">{me.roleLabels.map((r) => <Badge key={r} size="sm" variant="light">{r}</Badge>)}</Group>)}
          </Stack>
        </Card>
        <Card withBorder radius="lg" padding="lg">
          <Switch
            checked={me.remindersEnabled}
            onChange={(e) => save.mutate(e.currentTarget.checked)}
            label="Напоминания на почту за 3 дня до срока"
            description="Письмо о новом назначении приходит всегда. Сроки считаются до конца дня в вашем часовом поясе."
          />
        </Card>
      </Stack>
    </>
  );
}
